var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerFull_asianWinterGames"},[_c('CompreSportsMeetCommon',{attrs:{"bigSportsList":_vm.bigSportsList,"containerFullClassName":_vm.containerFullClassName,"defaultPath":_vm.defaultPath,"axiosBaseUrl":_vm.axiosBaseUrl,"sportCompetitionType":_vm.sportCompetitionType,"themeSeasonArr":_vm.themeSeasonArr}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }